<template>
  <div style="padding: 20px">
      <vxe-table
              :data="dataList"
              :loading="dataListLoading"
              empty-text="没有更多数据了！"
      >
          <vxe-table-column type="seq" width="60"></vxe-table-column>
          <vxe-table-column
                  field="reportBase.reportName"
                  title="任务名称"
          ></vxe-table-column>
          <vxe-table-column width="200"
                            field="reportBase.startTime"
                            title="开始时间"
          ></vxe-table-column>
          <vxe-table-column field="reportBase.endTime" width="200"
                            title="截止时间"></vxe-table-column>

          <vxe-table-column
                  field="state"
                  title="申报状态"
                  width="100"
                  :formatter="formatState"
          ></vxe-table-column>
          <vxe-column title="操作" width="200">
              <template #default="{ row }">
                  <vxe-button
                          v-if="!row.reportBase.hasOutTime"
                          type="text"
                          icon="vxe-icon--edit-outline"
                          @click="editEvent(row)"
                  >申报</vxe-button>
                  <vxe-button
                          v-else
                          type="text"
                          icon="vxe-icon--edit-outline"
                          @click="editEvent(row)"
                  >更新基本信息</vxe-button>
                  <vxe-button
                          type="text"
                          icon="vxe-icon--search"
                          @click="viewEvent(row)"
                  >查看</vxe-button>
              </template>
          </vxe-column>
      </vxe-table>
      <!-- 分页 -->
      <vxe-pager
              background
              v-model:current-page="pageIndex"
              v-model:page-size="pageSize"
              @page-change="pageChange"
              :total="totalPage"
              :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'Sizes', 'Total']"
      >
      </vxe-pager>
      <vxe-modal
              v-model="showModal"
              id="report-modal"
              :title="formData.reportBase ? formData.reportBase.reportName:'基本信息上报'"
              width="1200"
              min-width="600"
              min-height="600"
              :fullscreen="fullScreen"
              lock-scroll="false"
              show-zoom="true"
              resize
              destroy-on-close="true"
      >
          <template #default>
              <el-tabs type="border-card">
                  <el-tab-pane label="基本信息">
                      <vxe-form  :data="formData" :rules="formRules" title-align="right"  ref="formRef"
                                 title-width="200" >
                          <vxe-form-item title="法人信息" title-align="left" :title-width="400" :span="24"
                                         :title-prefix="{icon: 'vxe-icon--info'}"></vxe-form-item>
                          <vxe-form-item field="compName" title="医疗机构名称" :span="12" :item-render="{}">
                              <vxe-input v-model="formData.compName" :readonly="disabled" placeholder="请输入名称"></vxe-input>
                          </vxe-form-item>
                          <vxe-form-item field="creditCode" title="统一社会信用代码" :span="12" :item-render="{}">
                              <vxe-input v-model="formData.creditCode" :readonly="disabled" placeholder="请输入统一社会信用代码"></vxe-input>
                          </vxe-form-item>
                          <vxe-form-item field="regAddrCode" title="注册地址行政区划" :span="12" :item-render="{}">
                              <el-cascader size="small"  placeholder="注册地址行政区划" :disabled="disabled"
                                      v-model="regAddrCode"
                                      :options="areaOptions"
                                      @change="regAddrCodeChange"></el-cascader>
                          </vxe-form-item>
                          <vxe-form-item field="regAddr" title="注册地址" :span="12" :item-render="{}">
                              <vxe-input v-model="formData.regAddr" :readonly="disabled" placeholder="请输入注册地址"></vxe-input>
                          </vxe-form-item>
                          <vxe-form-item field="busAddrCode" title="单位地址行政区划" :span="12" :item-render="{}">
                              <el-cascader size="small" placeholder="单位地址行政区划" :disabled="disabled"
                                      v-model="busAddrCode"
                                      :options="areaOptions"
                                      @change="busAddrCodeChange"></el-cascader>
                          </vxe-form-item>
                          <vxe-form-item field="busAddr" title="单位地址" :span="12" :item-render="{}">
                              <vxe-input v-model="formData.busAddr" :readonly="disabled" placeholder="请输入单位地址"></vxe-input>
                          </vxe-form-item>

                          <vxe-form-item field="principal" title="法定代表人（负责人）" :span="12" :item-render="{}">
                              <vxe-input v-model="formData.principal" :readonly="disabled" placeholder="请输入法定代表人（负责人）"></vxe-input>
                          </vxe-form-item>

                          <vxe-form-item field="economicCode" title="经济类型" :span="12" :item-render="itemRender.economicCode">

                          </vxe-form-item>
                          <vxe-form-item field="cardType" title="证件类型" :span="12" :item-render="itemRender.cardType">

                          </vxe-form-item>
                          <vxe-form-item field="idcard" title="证件号码" :span="12" :item-render="{}">
                              <vxe-input v-model="formData.idcard" :readonly="disabled"  placeholder="请输入证件号码"></vxe-input>
                          </vxe-form-item>


                          <vxe-form-item title="基本信息" title-align="left" :title-width="400" :span="24"
                                         :title-prefix="{icon: 'vxe-icon--info'}"></vxe-form-item>

                          <vxe-form-item field="serviceObject" title="服务对象" :span="12" :item-render="{}">
                              <vxe-radio-group v-model="formData.serviceObject" :disabled="disabled">
                                  <vxe-radio label="01" content="社会"></vxe-radio>
                                  <vxe-radio label="02" content="内部"></vxe-radio>
                              </vxe-radio-group>
                          </vxe-form-item>
                          <vxe-form-item field="compType" title="单位类别" :span="12" :item-render="itemRender.compType">

                          </vxe-form-item>
                          <vxe-form-item field="compLevel" title="机构级别" :span="12" :item-render="{}">
                              <vxe-radio-group v-model="formData.compLevel" :disabled="disabled">
                                  <vxe-radio label="01" content="一级"></vxe-radio>
                                  <vxe-radio label="02" content="二级"></vxe-radio>
                                  <vxe-radio label="03" content="三级"></vxe-radio>
                                  <vxe-radio label="04" content="未评定"></vxe-radio>
                              </vxe-radio-group>
                          </vxe-form-item>
                          <vxe-form-item field="compNature" title="经营性质" :span="12" :item-render="{}">
                              <vxe-radio-group v-model="formData.compNature" :disabled="disabled">
                                  <vxe-radio label="01" content="营利性"></vxe-radio>
                                  <vxe-radio label="02" content="非营利性（政府）"></vxe-radio>
                                  <vxe-radio label="03" content="非营利性（非政府）"></vxe-radio>
                              </vxe-radio-group>
                          </vxe-form-item>
                          <vxe-form-item field="healthLicense" title="医疗机构执业许可证/备案号" :span="12" :item-render="{}">
                              <vxe-input v-model="formData.healthLicense" :readonly="disabled" placeholder="请输入医疗机构执业许可证备案号"></vxe-input>
                          </vxe-form-item>
                          <!--<vxe-form-item field="allowOrg" title="行政许可机关名称" :span="12" :item-render="itemRender.allowOrg">-->

                          <!--</vxe-form-item>-->

                          <vxe-form-item field="operateDate" title="批准日期" :span="12" :item-render="{}">
                              <vxe-input v-model="formData.operateDate" :readonly="disabled" placeholder="请输入批准日期" type="date"></vxe-input>
                          </vxe-form-item>
                          <vxe-form-item field="licenseEnd" title="许可证截止日期" :span="12" :item-render="{}">
                              <vxe-input v-model="formData.licenseEnd" :readonly="disabled" placeholder="请输入许可证截止日期" type="date"></vxe-input>
                          </vxe-form-item>
                          <vxe-form-item field="reCheckDate" title="下一校验日期" :span="12" :item-render="{}">
                              <vxe-input v-model="formData.reCheckDate" :readonly="disabled" placeholder="请输入下一校验日期" type="date"></vxe-input>
                          </vxe-form-item>
                          <vxe-form-item field="specialtiesName" title="诊疗科目" :span="12" :item-render="{}">
                              <vxe-input v-model="formData.specialtiesName" :readonly="disabled" placeholder="请输入诊疗科目"></vxe-input>
                          </vxe-form-item>
                          <vxe-form-item field="technology" title="诊疗技术" :span="24" :item-render="{}">
                              <vxe-input v-model="formData.technology" :readonly="disabled" placeholder="请输入诊疗科目"></vxe-input>
                          </vxe-form-item>

                          <vxe-form-item field="bedAmount" title="床位数" :span="12" :item-render="{}">
                              <vxe-input v-model="formData.bedAmount" :readonly="disabled" placeholder="请输入床位数" type="number"></vxe-input>
                          </vxe-form-item>
                          <vxe-form-item field="toothAmount" title="牙椅数" :span="12" :item-render="{}">
                              <vxe-input v-model="formData.toothAmount" :readonly="disabled" placeholder="请输入牙椅数" type="number"></vxe-input>
                          </vxe-form-item>

                          <vxe-form-item field="isBlood" title="是否开展临床用血" :span="12" >
                              <vxe-radio-group v-model="formData.isBlood" :disabled="disabled">
                                  <vxe-radio label="1" content="是"></vxe-radio>
                                  <vxe-radio label="0" content="否"></vxe-radio>
                              </vxe-radio-group>
                          </vxe-form-item>
                          <vxe-form-item field="cdoctorRecord" title="中医备案" :span="12" >
                              <vxe-radio-group v-model="formData.cdoctorRecord" :disabled="disabled">
                                  <vxe-radio label="1" content="是"></vxe-radio>
                                  <vxe-radio label="0" content="否"></vxe-radio>
                              </vxe-radio-group>
                          </vxe-form-item>
                          <vxe-form-item title="动态信息" title-align="left" :title-width="400" :span="24"
                                         :title-prefix="{icon: 'vxe-icon--info'}"></vxe-form-item>

                          <vxe-form-item field="totalStaff" title="在岗职工数" :span="12" >
                              <vxe-input v-model="formData.totalStaff" :readonly="disabled" placeholder="请输入在岗职工数" type="number"></vxe-input>
                          </vxe-form-item>
                          <vxe-form-item field="certifiedDoctor" title="执业（助理）医师数" :span="12" :item-render="{}">
                              <vxe-input v-model="formData.certifiedDoctor" :readonly="disabled" placeholder="请输入执业（助理）医师数" type="number"></vxe-input>
                          </vxe-form-item>
                          <vxe-form-item field="ruralDoctor" title="乡村医生数" :span="12" :item-render="{}">
                              <vxe-input v-model="formData.ruralDoctor" :readonly="disabled" placeholder="请输入乡村医生数" type="number"></vxe-input>
                          </vxe-form-item>
                          <vxe-form-item field="regNurse" title="注册护士数" :span="12" :item-render="{}">
                              <vxe-input v-model="formData.regNurse" :readonly="disabled" placeholder="请输入注册护士数" type="number"></vxe-input>
                          </vxe-form-item>
                          <vxe-form-item field="pharmacist" title="药师（士）数" :span="12" :item-render="{}">
                              <vxe-input v-model="formData.pharmacist" :readonly="disabled" placeholder="请输入药师（士）数" type="number"></vxe-input>
                          </vxe-form-item>
                          <vxe-form-item field="medicalTech" title="医技人员数" :span="12" :item-render="{}">
                              <vxe-input v-model="formData.medicalTech" :readonly="disabled" placeholder="请输入医技人员数" type="number"></vxe-input>
                          </vxe-form-item>

                          <!--<vxe-form-item field="smechanism" title="监督机构" :span="12" :item-render="itemRender.smechanism">-->

                          <!--</vxe-form-item>-->
                          <!--<vxe-form-item field="sdepartment" title="监督科室" :span="12" :item-render="itemRender.sdepartment">-->

                          <!--</vxe-form-item>-->
                      </vxe-form>
                  </el-tab-pane>
                  <el-tab-pane label="附件上传">
                      <el-upload v-if="!disabled"
                              class="avatar-uploader"
                              action="/api/onlineMedical/medicalComp/upLoadAtt"
                              list-type="text"
                              name="files"
                              :show-file-list="false"
                              accept="image/*, video/mp4,	application/msword,	application/pdf,
                                    application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                              multiple
                              :before-upload="beforeAvatarUpload"
                              :on-remove="onRemove"
                              :on-success="onSuccess"
                      >
                          <el-button size="small" type="primary">点击上传</el-button>
                          <div slot="tip" class="el-upload__tip">只能上传图片、mp4视频、pdf、word，且不超过20MB</div>
                      </el-upload>
                      <div class="demo-image__preview" style="min-height: 200px">
                          <div v-for="item of formData.attachmentList" style="display: inline-block" :key="item.url">
                              <div v-if = "item.attType.indexOf('image') > -1" style="display: inline-block;position: relative;margin: 10px">
                                   <img :src="item.url" class="default-img" />
                                   <li v-if="!disabled" class="vxe-icon--close  remove-btn"  @click="onRemove(item)"></li>
                              </div>
                              <div v-else-if ="item.attType.indexOf('video') > -1" style="display: inline-block;position: relative">
                                  <video  :src="item.url" controls="controls"  class="default-video" >
                                      您的浏览器不支持视频。
                                  </video>
                                  <li v-if="!disabled" class="vxe-icon--close  remove-btn"  @click="onRemove(item)"></li>
                              </div>
                              <div v-else-if ="item.attType.indexOf('pdf') > -1" style="display: inline-block;position: relative">
                                  <span v-text="item.attName" style="position: absolute;bottom:0;left: 0;color: black" @click="showPdf(item.attPath)"></span>
                                  <img :src="file_pdf" class="default-img" />
                                  <li v-if="!disabled" class="vxe-icon--close  remove-btn"  @click="onRemove(item)"></li>
                              </div>
                              <div v-else style="display: inline-block;position:relative">
                                  <span v-text="item.attName" style="position: absolute;bottom:0;left: 0;color: black" @click.self="downloadFile(item.attPath,item.attName)"></span>
                                  <img v-if="item.attType.indexOf('word')> -1" :src="file_word" :alt="item.attName" class="default-img" />
                                  <img v-else-if="item.attType.indexOf('excel')> -1" :src="file_excel" :alt="item.attName" class="default-img"/>
                                  <li v-if="!disabled" class="vxe-icon--close  remove-btn"  @click="onRemove(item)"></li>
                              </div>


                          </div>
                      </div>

                  </el-tab-pane>

                  <vxe-form v-if="!disabled">
                      <vxe-form-item align="center" title-align="left" :span="24" >
                          <template #default>
                              <vxe-button type="button" @click="formStoreSubmit">暂存</vxe-button>
                              <vxe-button type="button" @click="formSubmit" v-if="canSubmit">提交</vxe-button>
                              <!--<vxe-button type="button" @click="formReset">重置</vxe-button>-->
                          </template>
                      </vxe-form-item>
                  </vxe-form>
              </el-tabs>
          </template>
      </vxe-modal>
  </div>
</template>

<script>
    import {useStore} from "vuex";
    import {basePage,
        baseDetail,
        exeBase} from "@/api/base/index";
    import {
        getAreaOptions,
        getDeptDictList,
        getShenFenZhengZiDian,
        getJingJIZiDian,
        getYiliao
    } from "@/api/dict";

    export default {
        name: "index",
        data(){
           return{
               store:useStore(),
               file_pdf:'/file_pdf.jpg',
               file_word:'/file_word.png',
               file_excel:'/file_excel.png',

               canSubmit:!window.sessionStorage.getItem("subUserId"),
               taskStateOptions:[{code:2,name:'完成'},{code:1,name:'进行中'},{code:3,name:'暂存'}],
               dataList: [],
               pageIndex: 1,
               pageSize: 10,
               totalPage: 0,
               dataListLoading: false,

               showModal:false,
               disabled:false,
               fullScreen:true,
               formData:{},
               regAddrCode:[],
               busAddrCode:[],
               formRules:{
                   compName: [{ required: true, message: '该项未必填项' }],
                   regAddr: [{ required: true, message: '该项未必填项' }],
                   regAddrCode: [{ required: true, message: '该项未必填项' }],
                   busAddr: [{ required: true, message: '该项未必填项' }],
                   busAddrCode: [{ required: true, message: '该项未必填项' }],
                   creditCode: [{ required: true, message: '该项未必填项' }],
                   principal: [{ required: true, message: '该项未必填项' }],
                   compType: [{ required: true, message: '该项未必填项' }],
                   totalStaff: [{ required: true, message: '该项未必填项' }],
                   regNurse: [{ required: true, message: '该项未必填项' }],
                   pharmacist: [{ required: true, message: '该项未必填项' }],
                   bedAmount: [{ required: true, message: '该项未必填项' }],
                   healthLicense: [{ required: true, message: '该项未必填项' }],
                   specialtiesName: [{ required: true, message: '该项未必填项' }],
                   technology: [{ required: true, message: '该项未必填项' }],
                   // allowOrg: [{ required: true, message: '该项未必填项' }],
                   // smechanism: [{ required: true, message: '该项未必填项' }],
                   // sdepartment: [{ required: true, message: '该项未必填项' }]
               },
               areaOptions:[],
               itemRender:{
                   economicCode:{name:'$select',disabled:this.disabled,options:[], placeholder:"请选择证件类型"},
                   cardType:{name:'$select',disabled:this.disabled,options:[],placeholder:"请选择证件类型" },
                   compType:{name:'$select',disabled:this.disabled,options:[],placeholder:"请选择单位类型"},
                   allowOrg:{name:'$select',disabled:this.disabled,options:[],placeholder:"请选择行政许可机关名称"},
                   // smechanism:{name:'$select',disabled:this.disabled,options:[], events: {change: this.smChange},placeholder:"请选择监督机构"},
                   // sdepartment:{name:'$select',disabled:this.disabled,options:[],placeholder:"请选择监督科室"},
               }

           }
        },
        mounted(){
            this.initDict();
            this.getDataList();
        },
        methods:{
            initDict(){
                // getDeptDictList({
                //     'kdJd':1,
                //     'kdType':1,
                // }).then((res)=>{
                //     if(res && res.code === 0){
                //         this.itemRender.smechanism.options = res.data;
                //     }
                // })
                getAreaOptions().then((res)=>{
                    if(res && res.code === 0){
                        this.areaOptions = res.data;
                    }
                })
                getShenFenZhengZiDian().then((res)=>{
                    if(res && res.code === 0){
                        let shenfenzhengdata = res.data;
                        for(let i=0;i< shenfenzhengdata.length;i++){
                            this.itemRender.cardType.options.push({label:shenfenzhengdata[i].label, value:shenfenzhengdata[i].value})
                        }
                    }

                })
                getYiliao().then((res)=>{
                    if(res && res.code === 0){
                        let danweileibiedata = res.data;
                        for(let i=0;i< danweileibiedata.length;i++){
                            this.itemRender.compType.options.push({label:danweileibiedata[i].name, value:danweileibiedata[i].code})
                        }
                    }

                })
                getJingJIZiDian().then((res)=>{
                    if(res && res.code === 0){
                        let jingjidata = res.data;
                        for(let i=0;i< jingjidata.length;i++){
                            this.itemRender.economicCode.options.push({label:jingjidata[i].label, value:jingjidata[i].value})
                        }
                    }
                })
            },
            //任务列表开始
            getDataList(){
                this.dataListLoading = true
                basePage({
                    'current': this.pageIndex,
                    'size': this.pageSize
                }).then((data) => {
                    if (data && data.code === 0) {
                        this.dataList = data.data.records
                        this.totalPage = data.data.total
                    } else {
                        this.dataList = []
                        this.totalPage = 0
                    }
                    this.dataListLoading = false
                })
            },
            pageChange(args){
                this.pageSize = args.pageSize;
                this.pageIndex = args.currentPage;
                this.getDataList()
            },
            formatState({cellValue,row,column}){
                for (let i=0; i< this.taskStateOptions.length;i++) {
                    if(cellValue === this.taskStateOptions[i].code) return this.taskStateOptions[i].name
                }
                return cellValue;
            },
            editEvent(row){
                this.disabled= false
                this.initFormData(row)
            },
            initFormData(row){
                baseDetail(row.id).then((res) =>{
                    if(res && res.code === 0){
                        this.formData = res.data;
                        if(this.formData.regAddrCode){
                            this.regAddrCode[0] = this.formData.regAddrCode.substr(0,4) + '00';
                            this.regAddrCode[1] = this.formData.regAddrCode.substr(0,6);
                            this.regAddrCode[2] = this.formData.regAddrCode;
                        };
                        if(this.formData.busAddrCode){
                            this.busAddrCode[0] = this.formData.busAddrCode.substr(0,4) + '00';
                            this.busAddrCode[1] = this.formData.busAddrCode.substr(0,6);
                            this.busAddrCode[2] = this.formData.busAddrCode;
                        }
                        // this.smChange();
                        this.showModal = true;
                        this.fullScreen = true;
                    }
                })
            },
            regAddrCodeChange(value){
                if(value.length > 0) this.formData.regAddrCode = value[value.length - 1]
                else this.formData.regAddrCode ='';
            },
            busAddrCodeChange(value){
                if(value.length > 0)this.formData.busAddrCode = value[value.length - 1];
                else this.formData.busAddrCode='';
            },
            smChange(){
                if(this.formData.smechanism)
                getDeptDictList({
                    'kdPid':this.formData.smechanism
                }).then((res)=>{
                    if(res && res.code === 0){
                        this.itemRender.sdepartment.options = res.data;
                    }
                });
            },
            beforeAvatarUpload(file){
                const isLt2M = file.size / 1024 / 1024 < 20
                if (!isLt2M) {
                    alert('上传文件大小不能超过 20MB!')
                }
                return isLt2M
            },
            // 文件上传
            onSuccess(response,file, fileList){
                if(response.code !== 0){
                    ElMessage({ message: response.msg, type: "error" });
                    return
                }
                this.formData.attachmentList.push(response.data[0])
            },
            onRemove(file){
                let url = '';
                if (file.response) {
                    url = file.response.data[0].url;
                } else if (file) {
                    url = file.url;
                }
                let i = this.formData.attachmentList.length;
                while (i){
                    i--
                    if(this.formData.attachmentList[i]['url'] === url){
                        this.formData.attachmentList.splice(i, 1);
                        return
                    }

                }
            },
            formSubmit(){
                const that = this
                this.$refs['formRef'].validate(function(errMap){
                    let errLength = Object.keys(errMap).length;
                    if(errLength === 0){
                        that.submitEvent();
                    }
                });
            },
            formReset(){
                this.$confirm('此操作将清空所有填写项, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$refs['formRef'].reset();
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消重置'
                    });
                });

            },
            // 暂存
            formStoreSubmit(){
                exeBase(this.formData,true).then((res)=>{
                    if(res && res.code === 0){
                        this.showModal = false;
                        this.getDataList();
                    }
                })
            },
            submitEvent(){
                if(this.formData.attachmentList && this.formData.attachmentList.length === 0){
                    this.$confirm('您没有上传任何附件文件, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        exeBase(this.formData,false).then((res)=>{
                            if(res && res.code === 0){
                                this.showModal = false;
                                this.getDataList();
                                this.store.commit("setWorkTotal");
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消提交'
                        });
                    });
                }else{
                    exeBase(this.formData,false).then((res)=>{
                        if(res && res.code === 0){
                            this.showModal = false;
                            this.getDataList();
                            this.store.commit("setWorkTotal");
                        }
                    })
                }
            },
            viewEvent(row){
                this.disabled = true;
                this.initFormData(row)
            },
            showPdf(pdfUrl){
                window.open(pdfUrl, '_blank');
            },
            downloadFile(path,name){
                let a = document.createElement("a");
                a.download = name;
                a.href = path;
                a.click();
            },
        }
    }
</script>

<style scoped>
    .default-img{
        height:180px;
        display:inline-block;

    }
    .default-video{
        height:180px;
        display:inline-block;
    }
    .remove-btn{
        position: absolute;
        top: -5px;
        right:  -5px;
    }
    .remove-btn:hover{
        width: 20px;
        height: 20px;
        line-height: 20px;
        font-size: 18px;
        border-radius: 10px;
        border: 1px solid #000;

    }
</style>
